import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import * as actions from "actions";
import Section from "components/Section";
import ProductCarousel from "components/product";
import ServiceHeader from "components/ServiceHeader";
import ServiceBottom from "components/ServiceBottom";
import Layout from "layout/Layout";
import ReactDOM from 'react-dom';

class BusinessPage extends Component {
  componentDidMount() {
    let id = this.props.history.location.pathname;
    while (id.charAt(0) === "/") {
      id = id.substr(1);
    }
    // if(this.props.business_slug != id) {
      this.props.getPageDetails(id);
    // }
    ReactDOM.findDOMNode(this).scrollIntoView();
  }

  componentDidUpdate() {
    this.props.changePageTitle(`${this.props.title} | Vibo Vibo`);
    this.props.setBusinessLocationId(this.props.business_locations.id);
  }

  componentWillUnmount() {
    this.props.businessPageReset();
  }

  render() {
    if (this.props.business_locations === null) {
      return (
        <React.Fragment>
          <h2> Business is currently not avaliable</h2>
        </React.Fragment>
      );
    }

    const productDis =
      this.props.photos.length !== 0 ? (
        <ProductCarousel products={this.props.photos} />
      ) : null;

    const productDescription = this.props.description;
    console.log("IMAGEINBUSINESS",this.props.photos);
    
    return (
      <Layout>
        <Helmet>
          <title>{this.props.pageTitle}</title>
        </Helmet>
        <Section>
          <ServiceHeader
            title={this.props.title}
            address={this.props.business_locations.address}
            // change business name
            id={this.props.business_locations.businessname}
            branch={this.props.business_locations._id}
            business_slug={this.props.business_slug}
            logo={this.props.logo}
            phonenumber={this.props.business_locations.phonenumber}
            businessemail={this.props.owner_details.email}
            website={this.props.website}
          />
        </Section>
        <Section>
          <h2>Description</h2>
          <p>{productDescription}</p>
          <h2>Photos</h2>
          {productDis || <div>Images Not Added</div>}
        </Section>
        <Section>
          <ServiceBottom
            operations={this.props.business_locations.operations}
            services={this.props.business_locations.services_offered}
          />
        </Section>
      </Layout>
    );
  }
}

const mapStateToProps = ({ business, changeTitle, customerBooking }) => ({
  title: business.name,
  description: business.description,
  links: business.links,
  logo: business.logo ? business.logo.url : 'https://via.placeholder.com/150x150',
  business_locations: business.business_locations !== 0 ? business.business_locations[0] : null,
  pageTitle: changeTitle.pageTitle,
  id: customerBooking.businessId,
  business_slug: business.business_slug,
  photos:business.photos,
  owner_details:business.owner_details,
  website:business.website
});

const mapDispatchToProps = dispatch => ({
  changePageTitle: payload => dispatch(actions.setTitleOfPage(payload)),
  getPageDetails: id => dispatch(actions.getBusinessPage(id)),
  setBusinessLocationId: id => dispatch(actions.setBusinessLocationIds(id)),
  businessPageReset: () => dispatch(actions.businessPageReset()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BusinessPage)
);



// WEBPACK FOOTER //
// ./containers/BusinessPage.js